import React from 'react'
import ProdIOOExoSumViewRow from './ProdIOOExoSumViewRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOExoSumView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value = "Output Summary"/></span>
                    </UiTitle>
                    <UiAction>
                        <FormWrapper customWrapper="" formObject={formObject} headerKey="viewConfig" 
                            action={{ paramName: "addOutputBtn" }} >
                            <span className="uiSpacerH5"><SarasTrans value="Step 1: Add Order Output" /></span>
                            <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                                action={{ actionId: "new", actionName: "prodIOAddOOUT", 
                                paramName: "addOutputBtn",
                                actionParam: { actionType: "addOutput", pathKey: "OOUT", viewKey: "addEXOItem" }, 
                                containerKey: "popup" }}
                                text={<SarasTrans value="Add Output" />}>
                            </FormButton>
                        </FormWrapper>
                        <div className="uiSpacerH10"></div>
                        <FormWrapper customWrapper="" formObject={formObject} headerKey="viewConfig" 
                            action={{ paramName: "submitQCBtn" }} >
                            <span className="uiSpacerH5"><SarasTrans value="Step 2: Submit to QC" /></span>
                            <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton uiSpacerH5"
                                action={{ actionId: "new", actionName: "prodIOAddOQCE", 
                                paramName: "submitQCBtn",
                                actionParam: {actionType : "submitQC", pathKey:"OQCE", viewKey: "addQCEItem"},
                                containerKey: "popup" }}
                                text={<SarasTrans value="Submit to QC" />}>
                            </FormButton>
                        </FormWrapper>
                        <div className="uiSpacerH10"></div>
                        <span className="uiSpacerH5"><SarasTrans value="Send to Stock" /></span>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new", 
                            paramName: "returnRMBtn",
                            actionParam: {actionType : "returnRMOutput", pathKey:"OOMR", viewKey:"addReturn"},
                            containerKey: "popup" }}
                            text={<SarasTrans value="Return SF / NIR" />}>
                        </FormButton>
                        <FormButton formObject={formObject} headerKey="viewConfig" className="uiActionButton"
                            action={{ actionId: "new", 
                            paramName:"returnOutputBtn",
                            actionParam: {actionType : "returnOutput", pathKey:"OOFR", viewKey:"addReturn"},
                            containerKey: "popup" }}
                            text={<SarasTrans value="Return Output" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable uiProductionTable uiRawDataView" style={{ minWidth: "1180px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnRight uiColumnQty uiColumnGroupSplit"><SarasTrans value="Expected" /></li>
                                <FormWrapper formObject={formObject} headerKey="viewConfig" action={{ paramName: "enableQC" }} >
                                    <li className="uiColumnRight uiColumnQty"><SarasTrans value="QCed" /></li>
                                    <li className="uiColumnRight uiColumnQty"><SarasTrans value="Passed" /></li>
                                    <li className="uiColumnRight uiColumnQty uiColumnGroupSplit"><SarasTrans value="Failed" /></li>
                                </FormWrapper>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Available" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Returned" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Type" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOExoSumViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOExoSumView, "prodIOEOSum", "prodIOEOGroup");
